var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-container my-2 mx-4"},[_c('div',{staticClass:"tree-path",domProps:{"innerHTML":_vm._s(_vm.getFormattedTreePath())}})])
}
var staticRenderFns = []

export { render, staticRenderFns }